import prettyBytes from 'pretty-bytes';

type FileSizeProps = {
  bytes: number;
};

export const FileSize = ({ bytes }: FileSizeProps) => (
  <>{prettyBytes(bytes)}</>
);

export default FileSize;
